/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ItemRegistry, ItemRegistryItemProps } from "@adapptio/lib-shared";

/**
 * Blueprint Template props
 */
export interface IBlueprintTemplatesProps extends ItemRegistryItemProps {
	label: string;
	blueprintFilename: string;
	resourceType: string;
	getContent: (id: string, params?: { [K: string]: unknown }) => string;
}

/**
 * Blueprint Templates registry
 */
export type IBlueprintTemplatesRegistry = ItemRegistry<IBlueprintTemplatesProps>;

export class BlueprintTemplatesRegistry extends ItemRegistry<IBlueprintTemplatesProps> {}
